$('.choice').on('click', '.choice__placeholder', function () {
  $(this).siblings('.choice__options').slideToggle()
})
